import type { TOC } from '@ember/component/template-only';

const ClientsAccountsNewRouteTemplate: TOC<object> = <template>{{outlet}}</template>;

export default ClientsAccountsNewRouteTemplate;
